/**
 * AlmadarPostWhyWeStartedAlmadarENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostWhyWeStartedAlmadarENPostPage
 */

import { useAlmadarPostWhyWeStartedAlmadarENPostPageLogic } from '@/hooks/traits/useAlmadarPostWhyWeStartedAlmadarENPostPageLogic';
import type { AlmadarPostWhyWeStartedAlmadarENPostPageConfig } from '@/hooks/traits/useAlmadarPostWhyWeStartedAlmadarENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostWhyWeStartedAlmadarENPostView as AlmadarPostWhyWeStartedAlmadarENPostViewEntity } from '@app/shared';
import { AlmadarPostWhyWeStartedAlmadarENPostView } from '@/components/traits/AlmadarPostWhyWeStartedAlmadarENPostView';
import { Box } from '@almadar/ui/components';
import { AlmadarPostWhyWeStartedAlmadarENPostHeaderView } from '@/components/traits/AlmadarPostWhyWeStartedAlmadarENPostHeaderView';
import { Stack } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { AlmadarPostWhyWeStartedAlmadarENPostFooterView } from '@/components/traits/AlmadarPostWhyWeStartedAlmadarENPostFooterView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostWhyWeStartedAlmadarENPostPageViewProps {
  config?: Partial<AlmadarPostWhyWeStartedAlmadarENPostPageConfig>;
}

export function AlmadarPostWhyWeStartedAlmadarENPostPageView({ config: propsConfig }: AlmadarPostWhyWeStartedAlmadarENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostWhyWeStartedAlmadarENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostWhyWeStartedAlmadarENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostWhyWeStartedAlmadarEN" trait="AlmadarPostWhyWeStartedAlmadarENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostWhyWeStartedAlmadarENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostWhyWeStartedAlmadarENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box paddingY="xl" bg="transparent" fullWidth={true}><Container padding="lg" size="xl" maxWidth="xl"><AlmadarPostWhyWeStartedAlmadarENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostWhyWeStartedAlmadarENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostWhyWeStartedAlmadarENPostPageView;
